/**
 * A short, colour-coded status word. Presentational only: every call site
 * decides its own `kind` and pre-resolves its own `label` through `t()` --
 * StatusPill owns no vocabulary of its own, the same split Blocking.tsx's
 * `copyFor` and Layout.tsx's `navLabel` make (a component renders, a nearby
 * pure function decides). That is what lets Task 13's Jobs view reuse it for
 * a job's status without this file knowing what a job is.
 *
 * DESIGN SPIKE: the look now comes from `components/ui/badge.tsx`, but the
 * `.status-pill` class and the `data-kind` attribute stay exactly where they
 * were -- they are what DOM suites 1 and 3 find this element by, and the pill
 * is the one component every table, card and panel in the app renders.
 */
import { Badge } from './ui/badge';

export type PillKind = 'ok' | 'warn' | 'error' | 'neutral';

export function StatusPill({ kind, label }: { kind: PillKind; label: string }) {
  return (
    <Badge className="status-pill" tone={kind} data-kind={kind}>
      {label}
    </Badge>
  );
}
